import {IAllManagersStore, initialState as allManagersInitialState} from "./main/components/manager/AllManagersReducer";
import {
    allProductStoreInitialState as allProductsInitialState,
    IAllProductsStore
} from "./main/components/product/AllProductsReducer";
import {
    IAllFlashReportsStore,
    initialState as allFlashReportsInitialState
} from "./main/components/flash-report/AllFlashReportsReducer";
import {
    IAllCapitalMarketAssumptionsStore,
    initialState as allCapitalMarketAssumptionsInitialState
} from "./main/components/capital-market-assumptions/AllCapitalMarketAssumptionsReducer";
import {
    IFlashReportState,
    initialState as flashReportInitialState
} from "./main/components/flash-report/flashReportReducer";
import {
    IMeetingNoteState,
    initialState as meetingNoteInitialState
} from "./main/components/meeting-note/meetingNoteReducer";
import {initialState as productInitialState, IProductState} from "./main/components/product/productReducer";
import {initialState as productStoreInitialState, IProductStore} from "./main/components/research/productStoreReducer";
import {IHeaderReducerState, initialState as headerInitialState} from "./main/components/base/header/HeaderReducer";
import {
    ISharedDocumentsPropsFromState,
    sharedDocumentsInitialState
} from "./main/components/shared-documents/SharedDocuments.reducer";
import {ISessionState, sessionInitialState} from "./main/components/session/SessionReducer";
import {
    initialState as portfolioInitialState,
    IPortfolioAdminState
} from "./main/components/research/edit-portfolio/editPortfolioReducer";
import {IAdminState, initialState as adminInitialState} from "./main/components/admin/AdminReducer";
import {
    currentClientInitialState as clientInitialState,
    ICurrentClientState
} from "./main/components/client/ClientReducer";
import {RequestState} from "./main/components/common/commonStates";
import {IPlanSettings} from "./main/api/AuthApi";
import {
    initialState as thoughtLeadershipInitialState,
    IThoughtLeadershipState
} from "./main/components/thought-leadership/ThoughtLeadershipReducer";
import {IOddIQStore, oddIQInitialState} from "./main/components/odd-iq/OddIqReducer";
import {
    IPowerBiReportingStore,
    powerBiReportingInitialState
} from "./main/components/power-bi-reporting/PowerBiReporting.reducer";
import {initialState as planSettingsInitialState} from "./main/components/root/PlanSettings.reducer";
import {initialState as managerStrategiesInitialState} from "./main/components/manager/ManagerStrategiesReducer";
import {IManagerStrategiesState} from "./main/components/manager/ManagerStrategiesReducer";
import {
    IPortfolioPageState,
    portfolioPageInitialState
} from "./main/components/portfolio/PortfolioReducer";
import {IResearchPageState} from "./main/model/ResearchPageState.model";
import {initialState as researchPageInitialState} from "./main/components/research/ResearchPageReducer";

export interface IApplicationRootState {
    allManagersStore?: IAllManagersStore;
    allProductsStore?: IAllProductsStore;
    allFlashReportsStore?: IAllFlashReportsStore;
    allCapitalMarketAssumptionsStore?: IAllCapitalMarketAssumptionsStore;
    flashReportState?: IFlashReportState;
    meetingNoteRootState?: IMeetingNoteState;
    productPageState?: IProductState;
    productStore?: IProductStore;
    headerRootState?: IHeaderReducerState;
    sharedDocumentsRootState?: ISharedDocumentsPropsFromState;
    session?: ISessionState;
    portfolioAdminState?: IPortfolioAdminState;
    adminState?: IAdminState;
    currentClient?: ICurrentClientState;
    planSettings?: RequestState<IPlanSettings>;
    thoughtLeadership?: IThoughtLeadershipState;
    oddIQStore?: IOddIQStore;
    powerBiReportingStore?: IPowerBiReportingStore;
    managerStrategiesState?: IManagerStrategiesState;
    researchPageState?: IResearchPageState;
    portfolioPageState?: IPortfolioPageState;
}

export const applicationInitialState: IApplicationRootState = {
    allManagersStore: allManagersInitialState,
    allProductsStore: allProductsInitialState,
    allFlashReportsStore: allFlashReportsInitialState,
    allCapitalMarketAssumptionsStore: allCapitalMarketAssumptionsInitialState,
    flashReportState: flashReportInitialState,
    meetingNoteRootState: meetingNoteInitialState,
    productPageState: productInitialState,
    productStore: productStoreInitialState,
    headerRootState: headerInitialState,
    sharedDocumentsRootState: sharedDocumentsInitialState,
    session: sessionInitialState,
    portfolioAdminState: portfolioInitialState,
    adminState: adminInitialState,
    currentClient: clientInitialState,
    planSettings: planSettingsInitialState,
    thoughtLeadership: thoughtLeadershipInitialState,
    oddIQStore: oddIQInitialState,
    powerBiReportingStore: powerBiReportingInitialState,
    managerStrategiesState: managerStrategiesInitialState,
    researchPageState: researchPageInitialState,
    portfolioPageState: portfolioPageInitialState,
};